import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OrganizationService } from '../../../services/organization.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'modal-confirm-delete-account',
  template: require('./modal-confirm-delete-account.component.pug'),
  styles: [require('./modal-confirm-delete-account.component.css').toString()],
})
export class ModalConfirmDeleteAccountComponent implements OnInit {
  confirmName: string;
  public reason: Subject<any>;

  // Options to pass to the modal:
  inputName: string;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
    private watchAccount: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    this.reason.next(false);
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
    this.reason.next(false);
  }

  // -------------------------------------------------------------------
  isDisabled() {
    if (!this.confirmName || !this.inputName) {
      return true;
    }

    if (this.confirmName.toUpperCase() != this.inputName.toUpperCase()) {
      return true;
    }

    return false;
  }

  // -------------------------------------------------------------------
  destroyAccount(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.accountService.destroy(
      this.watchAccount.accountId().getValue(),
      () => {
        this.bsModalRef.hide();
        this.reason.next(true);
      },
      error => {
        onfailure(error);
      },
    );
  }
}
